import React from 'react';
// Import images
import img1 from '../../assets/images/main/mistress-md-professional-dominatrix-blue-boots-on-throne.jpg';
import img2 from '../../assets/images/main/mistress-md-professional-dominatrix-main-image.jpg';
import img3 from '../../assets/images/main/mistress-md-professional-dominatrix-in-pink-boots.jpg';
import img4 from '../../assets/images/main/mistress-md-professional-dominatrix-in-black-with-whip.jpg';
// Components
import MainContainerContent from '../general/MainContainerContent';
import GeneralPriceTable from '../general/GeneralPriceTable';
import { dominationRatesArray } from '../../utils/data/PriceData';

function DominationPageMainContainer() {
  return (
    <main role='main' className='grid pt-6 pb-12'>
      <MainContainerContent
        title='Submit to Your Mistress'
        subtitle='Domination. Discipline. Complete Surrender.'
        paraOne={`Enter my realm, where your purpose is to serve and obey. I am the one who commands, who controls, who breaks you down and builds you into exactly what I desire. Your will? Irrelevant. Your limits? Meant to be tested. Under my gaze, you are nothing but mine to use, tease, deny, and discipline.`}
        paraTwo={`Whether it’s psychological torment, physical restraint, or exquisite suffering, every moment with me is a lesson in your true place—beneath me. This is not a game. This is devotion. Book your session and learn what it truly means to be owned by a powerful, sadistic Mistress.`}
        images={[img1, img2, img3, img4]}
      />

      <GeneralPriceTable
        title='Domination Prices'
        rates={dominationRatesArray}
        depositMessage='A £60 deposit (non-negotiable & non-refundable) is required to secure a booking.'
        extraMessage='Extras apply for sessions involving mess, topless, or nudity.'
      />
    </main>
  );
}

export default DominationPageMainContainer;
